import React, { useRef, Suspense } from "react";

//
import styled from "styled-components";
import { motion } from "framer-motion";
import { Row, Col } from "react-bootstrap";
import Navbar from "../navbar/Navbar";
import waveHaikel from "../../images/wave-haikei-1.svg";
import clipPath from "../../images/arrow-left-2-icon.svg";

// R3F
import { Canvas, useFrame } from "@react-three/fiber";
import { OrbitControls, useProgress, useGLTF } from "@react-three/drei";

// React Spring
import { a, useTransition } from "@react-spring/web";

// Styled Components
const PrimaryContainer = styled.div`
  aspect-ratio: 963/300;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-image: url(${waveHaikel});
`;

const SecondaryContainer = styled.div`
  margin-top: 0rem;

  @media (min-width: 1024px) {
    margin-top: -2.5rem;
  }
`;

const Header = styled(motion.h1)`
  color: #111827;
  font-size: 1.875rem;
  line-height: 2.25rem;
  font-weight: 700;
  line-height: 1.25;

  @media (min-width: 768px) {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  @media (min-width: 1024px) {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  @media (min-width: 1280px) {
    font-size: 3rem;
    line-height: 1.2;
  }
`;

const Description = styled.p`
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
  font-size: 1rem;
  line-height: 1.5rem;

  @media (min-width: 1024px) {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  @media (min-width: 1280px) {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
`;

const TextContainer = styled.div`
  text-align: center;

  @media (min-width: 1024px) {
    text-align: left;
  }
`;

const Loader = () => {
  const { active, progress } = useProgress();
  const transition = useTransition(active, {
    from: { opacity: 1, progress: 0 },
    leave: { opacity: 0 },
    update: { progress },
  });
  return transition(
    ({ progress, opacity }, active) =>
      active && (
        <a.div className="loading" style={{ opacity }}>
          <div className="loading-bar-container">
            <a.div className="loading-bar" style={{ width: progress }}></a.div>
          </div>
        </a.div>
      )
  );
};

const Lights = () => {
  return (
    <>
      {/* Ambient Light illuminates lights for all objects */}
      <ambientLight intensity={0.3} />
      {/* Diretion light */}
      <directionalLight position={[10, 10, 5]} intensity={1} />
      <directionalLight
        castShadow={true}
        position={[0, 10, 0]}
        intensity={1.5}
        shadow-mapSize-width={1024}
        shadow-mapSize-height={1024}
        shadow-camera-far={50}
        shadow-camera-left={-10}
        shadow-camera-right={10}
        shadow-camera-top={10}
        shadow-camera-bottom={-10}
      />
      {/* Spotlight Large overhead light */}
      <spotLight intensity={1} position={[1000, 0, 0]} castShadow />
    </>
  );
};

const Model = ({ url }) => {
  // Loading the model
  const gltf = new useGLTF(url, true);

  // Creating rotation
  const ref = useRef();

  useFrame(() => {
    ref.current.rotation.y += 0.005;
  });

  return (
    <mesh ref={ref} position={[0.25, -0.25, 0]}>
      <primitive object={gltf.scene} dispose={null} />
    </mesh>
  );
};

const TwoColumnWithAnImage = ({
  heading = "Hello, My name is ",
  highlightedHeading = "Chai Pin Zheng",
  description = `I am currently a year 2 student at
  Singapore Polytechnic. I specialise in Full-stack Web
  Development, Data Engineering and Android Application
  Development!`,
}) => {
  return (
    <PrimaryContainer>
      <div className="vh-100 d-flex flex-column">
        <Navbar />
        <SecondaryContainer className="container banner col-xxl-8 py-5 py-md-0 px-4 px-md-0 flex-grow-1">
          <Row className="row-cols-1 row-cols-md-2 py-5 py-md-0 h-100">
            <Col className="col-md-5 d-flex order-first align-items-center">
              <TextContainer>
                <Header className="lead display-5 text-black">
                  {heading}
                  <span style={{ color: "#6415FF" }}>{highlightedHeading}</span>
                </Header>
                <Description className="text-black">{description}</Description>
              </TextContainer>
            </Col>
            <Col
              className="col-md-7 d-flex align-items-center pt-n5 p-md-0 g-5 py-2"
              style={{ backgroundImage: `url(${clipPath})` }}
            >
              <Canvas
                concurrent
                colorManagement
                camera={{ position: [3, 3, 3], fov: 70 }}
              >
                {/* Lights Component */}
                <Lights />
                <Suspense fallback={null}>
                  <Model url="./scene.gltf" />
                </Suspense>
                <OrbitControls />
              </Canvas>
            </Col>
          </Row>
        </SecondaryContainer>
      </div>
      <Loader />
    </PrimaryContainer>
  );
};

export default TwoColumnWithAnImage;
